module.exports = __webpack_public_path__ + "fonts/Vonnes-Light.07c61620.otf";